import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class MetaTagService {
    private renderer: Renderer2;
    constructor(private titleService: Title, private metaService: Meta) {}
    updateTags(title: string, description: string, currentUrl: string, imgUrl?: string, imgAlt?: string): void {
        this.titleService.setTitle(title);
        this.metaService.updateTag({ name: 'title', content: title });
        this.metaService.updateTag({ name: 'description', content: description });
        this.metaService.updateTag({ property: 'og:title', content: title });
        this.metaService.updateTag({ property: 'og:description', content: description });
        this.metaService.updateTag({ name: 'twitter:title', content: title });
        this.metaService.updateTag({ name: 'twitter:description', content: description });
        this.metaService.updateTag({ property: 'og:url', content: currentUrl });
        if (imgUrl && imgAlt) {
            this.metaService.updateTag({ name: 'twitter:image', content: imgUrl });
            this.metaService.updateTag({ property: 'og:image', content: imgUrl });
            this.metaService.updateTag({ property: 'og:image:alt', content: imgAlt });
            this.metaService.updateTag({ property: 'og:image:type', content: 'image/png' });
            this.metaService.updateTag({ property: 'og:image:width', content: '1200' });
            this.metaService.updateTag({ property: 'og:image:height', content: '627' });
        } else {
            // Remove existing image tags if present
            this.metaService.removeTag("name='twitter:image'");
            this.metaService.removeTag("property='og:image'");
            this.metaService.removeTag("property='og:image:alt'");
            this.metaService.removeTag("property='og:image:type'");
            this.metaService.removeTag("property='og:image:width'");
            this.metaService.removeTag("property='og:image:height'");
        }
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
            existingCanonical.setAttribute('href', currentUrl);
        } else {
            const link: HTMLLinkElement = this.renderer.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', currentUrl);
            this.renderer.appendChild(document.head, link);
        }
    }
}
